import { ACLFeature } from '../_models/acl-feature';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { Log } from 'ng2-logger';
import { UrlSegment } from '@angular/router';
import { of } from 'rxjs/observable/of';
import { zip } from 'rxjs/observable/zip';

const log = Log.create('Permissions');

@Injectable()
export class Permissions {

  private _features = new BehaviorSubject(this.features);

  /**
   * Check if role is sufficient
   *
   * @returns {Observable<boolean>}
   */
  canVisit(segment: UrlSegment[]): Observable<boolean> {
      log.info('canVisit', segment.join('/'));
      switch (segment.join('/')) {
        case 'management':
          return zip(...[this.hasFeature(ACLFeature.EXPORT_EXCEL_REGIONIZED_MODULE_PORTFOLIO),
                         this.hasFeature(ACLFeature.EXPORT_EXCEL_REGIONIZED_DRIVER_PORTFOLIO),
                         this.hasFeature(ACLFeature.ADMIN_PANEL)],
            (canExportModule, canExportDriver, canManage) => {
              return (canExportModule || canExportDriver) || canManage;
            });

        case 'logout':
        case 'unauthorized':
        case 'login':
            return of(true);

        case 'drilldown/modules':
          return this.hasFeature(ACLFeature.READ_MODULES);

        case 'drilldown/drivers':
          return this.hasFeature(ACLFeature.READ_DRIVERS);

        case 'drilldown/bridges':
          return this.hasFeature(ACLFeature.READ_BRIDGES);

        case 'drilldown/sensors':
          return this.hasFeature(ACLFeature.READ_SENSORS);

        case 'drilldown/sensor-accessories':
          return this.hasFeature(ACLFeature.READ_SENSOR_ACCESSORIES);

        default:
          return this.hasFeature(ACLFeature.ADMIN_PANEL);
      }
   }

  /**
   * Checks an acl feature against user roles
   *
   * @param {ACLFeature} feature
   * @returns {Observable<boolean>}
   */
  hasFeature(feature: ACLFeature): Observable<boolean> {
    return Observable.create((observer) => {
      this._features.subscribe(features => {
        observer.next(features.indexOf(feature) !== -1);
      });
    });
  }

  /**
   * Sets features for user in session
   *
   * @param {Array<ACLFeature>} features
   */
  set features(features: Array<ACLFeature>) {
    sessionStorage.setItem('features', JSON.stringify(features));
    this._features.next(features);
  }

  /**
   * Gets features from session
   *
   * @returns {any}
   */
  get features() {
    const features = JSON.parse(sessionStorage.getItem('features'));
    return features ? features : [];
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/permissions.ts